import { render } from "./SwdPreviewModal.vue?vue&type=template&id=15770c77"
import script from "./SwdPreviewModal.vue?vue&type=script&lang=js"
export * from "./SwdPreviewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__